// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"a22394d0","473":"c39c4f34","510":"b5f49b28","711":"c39c4f34","871":"aefa9c62"}[chunkId] + ".chunk.css";
};